export const COOKIE_TTL_SUBSCRIPTION_SUBSCRIBED = 60 * 60 * 24 * 365 // 1 year — user subscribed flag
export const COOKIE_TTL_BANNER_DISMISS = 60 * 60 * 24 * 3 // 3 days — banner closed by user
